module.exports = __webpack_public_path__ + "img/jamboard.2159554a.png";